export const PERFORMANCE_DECOMPOSITION_CHART_HEIGHT = 690;
